import {
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewEncapsulation,
} from '@angular/core';

import { CommonModule } from '@angular/common';

import { ItemTemplateDirective } from '@ose/directives';

@Component({
  selector: 'lib-filter-switch',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './filter-switch.component.html',
  styleUrl: './filter-switch.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FilterSwitchComponent {
  @ContentChildren(ItemTemplateDirective)
  items?: QueryList<ItemTemplateDirective>;

  @Output()
  itemChange = new EventEmitter<string>();

  @Input()
  activeItem?: string;

  @Input()
  cssClass?: string;

  @Input()
  itemClass?: string;

  @Input()
  listItemClass?: string;

  @Input()
  activeItemClass?: string;

  @Input()
  inactiveItemClass?: string;

  @Input()
  useDefaultSpacing = true;

  selectItem(itemName: string): void {
    this.activeItem = itemName;

    this.itemChange.emit(this.activeItem);
  }

  getItemClasses(item: ItemTemplateDirective): string {
    const classes: string[] = [];

    if (this.useDefaultSpacing) {
      classes.push('py-3', 'py-lg-3', 'px-2', 'px-lg-3');
    }

    if (this.itemClass) {
      classes.push(this.itemClass);
    }

    if (!item.disabled) {
      if (item.libItemTemplate === this.activeItem) {
        if (this.activeItemClass) {
          classes.push(this.activeItemClass);
        }
      } else {
        if (this.inactiveItemClass) {
          classes.push(this.inactiveItemClass);
        }
      }
    }

    return classes.join(' ');
  }
}
